import { render } from "./QuoteTweet.vue?vue&type=template&id=74908266&ts=true"
import script from "./QuoteTweet.vue?vue&type=script&lang=ts"
export * from "./QuoteTweet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__